if (!customElements.get("localization-form")) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.details = this.closest('details');
      this.input = this.querySelector('input[name="language_code"], input[name="country_code"]');

      this.querySelectorAll('a').forEach(item => {
        item.addEventListener('click', this.onItemClick.bind(this));
      });

      if (this.details) {
        this.details.addEventListener('toggle', () => {
          if (this.details.open) {
            this.details.setAttribute('aria-expanded', 'true');
              document.addEventListener('click', this.onDocumentClick);
              document.addEventListener('keyup', this.onEscapeKey);
          } else {
            this.details.setAttribute('aria-expanded', 'false');
            document.removeEventListener('click', this.onDocumentClick);
            document.removeEventListener('keyup', this.onEscapeKey);
          }
        });
      }
    }

    onDocumentClick = (event) => {
      if (!this.details.contains(event.target)) {
        this.details.open = false;
      }
    }

    onEscapeKey = (event) => {
      if (event.key === 'Escape') {
        this.details.open = false;
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (form && this.input) {
        this.input.value = event.currentTarget.dataset.value;
        form.submit();
      }
    }

    close() {
      if (this.details && this.details.hasAttribute('open')) {
        this.details.removeAttribute('open');
        this.details.setAttribute('aria-expanded', 'false');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keyup', this.onEscapeKey);
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
